export default __webpack_public_path__ + "static/media/bag-1.9fcc0eac.png";